import React, { useEffect, useRef, useState } from "react";
import { jsPDF } from "jspdf";
import Home from "@/pages/Home";
import Methodology from "@/pages/Methodology";
import TheWork from "@/pages/TheWork";
import FinalTribute from "@/pages/FinalTribute";
import About from "@/pages/About";
import Commission from "@/pages/Commission";
import Faq from "@/pages/Faq";
import FromThePage from "@/pages/FromThePage";
import FromTheBooklet from "@/pages/FromTheBooklet";

// Preview-only utility: exports all site copy as a PDF.
// It is intentionally hidden on any deployed/live environment.
const PAGES = [
  { title: "Home", path: "/", Component: Home },
  { title: "The Method", path: "/the-method", Component: Methodology },
  { title: "The Work", path: "/the-work", Component: TheWork },
  { title: "The Final Tribute", path: "/final-tribute", Component: FinalTribute },
  { title: "The Anthropologist", path: "/the-anthropologist", Component: About },
  { title: "Commission", path: "/commission", Component: Commission },
  { title: "FAQ", path: "/faq", Component: Faq },
  { title: "From The Page (Life Study Sample)", path: "/from-the-page", Component: FromThePage },
  { title: "From The Booklet (Final Tribute Sample)", path: "/from-the-booklet", Component: FromTheBooklet },
];

export const CopyExport = () => {
  const [generating, setGenerating] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!generating) return;
    const id = setTimeout(() => {
      const root = containerRef.current;
      const doc = new jsPDF({ unit: "pt", format: "a4" });
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();
      const margin = 56;
      const maxW = pageW - margin * 2;
      let y = margin;

      // Cover
      doc.setFont("times", "italic");
      doc.setFontSize(26);
      doc.text("The Raven's Quill", margin, y + 20);
      doc.setFont("times", "normal");
      doc.setFontSize(11);
      doc.text("Complete Website Copy", margin, y + 44);
      doc.text(new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" }), margin, y + 62);

      const sections = root.querySelectorAll("[data-copy-section]");
      sections.forEach((section) => {
        doc.addPage();
        y = margin;
        const title = section.getAttribute("data-copy-title");
        const pathLabel = section.getAttribute("data-copy-path");

        doc.setFont("times", "bold");
        doc.setFontSize(18);
        doc.text(title, margin, y);
        y += 16;
        doc.setFont("times", "italic");
        doc.setFontSize(9);
        doc.setTextColor(122, 46, 46);
        doc.text(pathLabel, margin, y);
        doc.setTextColor(28, 26, 23);
        y += 22;

        doc.setFont("times", "normal");
        doc.setFontSize(11);
        const text = (section.innerText || "").replace(/\n{3,}/g, "\n\n").trim();
        const paragraphs = text.split("\n").map((p) => p.trim()).filter(Boolean);
        paragraphs.forEach((p) => {
          const lines = doc.splitTextToSize(p, maxW);
          lines.forEach((line) => {
            if (y > pageH - margin) {
              doc.addPage();
              y = margin;
            }
            doc.text(line, margin, y);
            y += 15;
          });
          y += 6;
        });
      });

      doc.save("the-ravens-quill-website-copy.pdf");
      setGenerating(false);
    }, 500);
    return () => clearTimeout(id);
  }, [generating]);

  return (
    <>
      <button
        type="button"
        onClick={() => setGenerating(true)}
        disabled={generating}
        data-testid="copy-export-button"
        className="text-[10px] uppercase tracking-[0.24em] border border-[#7A2E2E] text-[#7A2E2E] px-4 py-2 hover:bg-[#7A2E2E] hover:text-[#F4F1EA] transition-colors disabled:opacity-50"
      >
        {generating ? "Preparing PDF..." : "Download Website Copy (PDF)"}
      </button>

      {generating && (
        <div
          ref={containerRef}
          aria-hidden="true"
          style={{ position: "fixed", left: "-10000px", top: 0, width: "760px" }}
        >
          {PAGES.map(({ title, path, Component }) => (
            <div key={path} data-copy-section data-copy-title={title} data-copy-path={path}>
              <Component />
            </div>
          ))}
        </div>
      )}
    </>
  );
};
